// extracted by mini-css-extract-plugin
export default {"container":"ProfilePage_container__pL9on"};